export function getResourcesDashboardPath() {
  return '/resources';
}

export function getRegionDashboardPath(provider_uuid, region_uuid) {
  return `/resources/provider/${provider_uuid}/region/${region_uuid}/dashboard`;
}

export function getCollectionDashboardPath(entity_type) {
  return `/${entity_type}`;
}

export function getProjectsDashboardPath() {
  return '/projects';
}

export function getProjectDetailsPath(project_id) {
  return `/project/details/${project_id}`;
}

export function getProjectAuthorizerFormPath(project_id, authorizer_id) {
  const path = `/project/details/${project_id}/authorizer/edit`;
  if (!authorizer_id) {
    return path;
  }
  return `${path}?authorizer=${encodeURIComponent(authorizer_id)}`;
}
